import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import styles from './toggleBox.module.scss';
export function ToggleBox({ className, headComponent: Head, headClassName, title, textProps, helpIcon, isOpen: propsIsOpen, onChange: propsOnChange, input, children, disabled, }) {
    const [isOpen, setIsOpen] = useState(propsIsOpen);
    const onChange = useCallback((isOpen) => {
        propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange(isOpen);
        setIsOpen(isOpen);
    }, [propsOnChange, setIsOpen]);
    useEffect(() => {
        setIsOpen(propsIsOpen);
    }, [propsIsOpen]);
    return (_jsxs(Box, Object.assign({ background: "neutral.100", borderRadius: "100", className: className }, { children: [_jsx(Head, { title: title, isOpen: isOpen, onChange: onChange, input: input, textProps: textProps, helpIcon: helpIcon, className: headClassName, disabled: disabled }), _jsx("div", Object.assign({ className: classnames(styles.children, {
                    [styles.childrenIsOpen]: isOpen,
                }) }, { children: children }))] })));
}
